import { FC } from 'react';
import ISvgProps from '../SvgLoader/ISvgProps';

export const ExpiredLinkDesktopIcon: FC<ISvgProps> = ({ primaryColor = '#191919' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
			<circle cx="40" cy="40" r="40" fill="url(#paint0_linear_1448_4837)" fillOpacity="0.5" />
			<path
				d="M24.1665 53.666H55.8332V55.8327H24.1665V53.666ZM28.3332 39.9993H30.4998V51.0827H28.3332V39.9993ZM36.2498 39.9993H38.4165V51.0827H36.2498V39.9993ZM42.5832 39.9993H44.7498V51.0827H42.5832V39.9993ZM49.4998 39.9993H51.6665V51.0827H49.4998V39.9993ZM24.1665 32.0827L39.9998 24.166L55.8332 32.0827V38.416H24.1665V32.0827ZM26.3332 34.0397V36.2494H53.6665V34.0397L39.9998 26.7063L26.3332 34.0397ZM39.9998 33.666C39.5799 33.666 39.1772 33.4992 38.8803 33.2023C38.5833 32.9053 38.4165 32.5026 38.4165 32.0827C38.4165 31.6628 38.5833 31.26 38.8803 30.9631C39.1772 30.6662 39.5799 30.4993 39.9998 30.4993C40.4198 30.4993 40.8225 30.6662 41.1194 30.9631C41.4164 31.26 41.5832 31.6628 41.5832 32.0827C41.5832 32.5026 41.4164 32.9053 41.1194 33.2023C40.8225 33.4992 40.4198 33.666 39.9998 33.666Z"
				fill="#44345E"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1448_4837"
					x1="40"
					y1="0"
					x2="40"
					y2="80"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#BF9CFA" stopOpacity="0.6" />
					<stop offset="1" stopColor="#8A43FF" stopOpacity="0.8" />
				</linearGradient>
			</defs>
		</svg>
	);
};
